<template>
  <v-container grid-list-lg fluid>
    <v-row>
      <v-col cols="12" v-if="!currentOrganization">
        <v-card>          
          <v-card-text>
            <v-layout align-center justify-center row fill-height>              
              <AttachOrg> </AttachOrg>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>

      
      <v-col v-else cols="12">
        <v-row>
          <v-col cols="12">
            <h1 class="text-center text-h4 font-weight-medium">
              {{ currentOrganization.organizationName }}
            </h1>
          </v-col>
          <v-col cols="12">
            <LocationList ></LocationList>
          </v-col>
          <!-- <v-col cols="12">
            <Stores />
          </v-col>
          <v-col cols="12">
            <Groups> </Groups>
          </v-col>
          <v-col cols="12">
            <TwoPointOBatch> </TwoPointOBatch>
          </v-col> -->
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import Stores from "./Tiles/Store";
import Groups from "./Tiles/Groups";
import TwoPointOBatch from "./Tiles/TwoPointOBatch";
import ClickImage from "./Tiles/ClickImage";
const AttachOrg = () => import("../Layout/components/AttachOrg");
import LocationList from "@/pages/Location/components/List.vue"
// import locationService from '@/pages/Location/service.js'

export default {
  name: "home",
  data() {
    return {
      locations: []
    }
  },
  components: {
    Stores,
    AttachOrg,
    Groups,
    TwoPointOBatch,
    ClickImage,
    LocationList,
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"])
  },
};
</script>
